import styled from 'styled-components'

import LiveTooltip from 'live/components/ui/tooltip'

export const Card = styled.div`
    min-width: min-content;
    height: max-content;
    padding: 8px;
`

const pageHeight = '842px'

export const CardHeader = styled.div<{ emptyAlarms: boolean }>`
    position: relative;
    padding: 12px;
    width: 400px;
    border-radius: 3px;
    background: var(--gray-0);
    max-height: min-content;
    box-shadow: 1.66px 1.66px 4.97px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: row;
    gap: 12px;

    .card-label {
        line-height: 16px;
        font-size: 10px;
        color: var(--gray-700);
    }

    .card-details {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 70%;

        .card-title {
            color: var(--gray-900);
            font-size: 20px;
            font-family: var(--font-bold);
            display: flex;
            flex-direction: row;
            align-items: baseline;
            line-height: 24px;
            overflow: hidden;
            justify-content: space-between;

            .card-title-text {
                color: var(--gray-900);
                font-size: 20px;
                font-family: var(--font-bold);
                display: flex;
                flex-direction: column;
                text-align: left;
                align-items: baseline;
                line-height: 24px;
                max-width: 100%;
                word-wrap: break-word;
                flex-wrap: wrap;
                overflow: hidden;
                text-overflow: ellipsis;

                .card-title-button {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    word-wrap: break-word;
                    overflow-x: hidden;
                    overflow-y: hidden;
                    max-width: 100%;
                    gap: 5px;
                    word-break: break-all;
                    text-overflow: ellipsis;
                }
            }

            .card-asset-id {
                font-family: var(--font-semibold);
                line-height: 24px;
                font-size: 12px;
            }
        }

        .card-alarms {
            display: flex;
            align-items: center;
            gap: 4px;

            .fa-bell {
                font-size: 8px;
                font-weight: ${({ emptyAlarms }) => (emptyAlarms ? 400 : 900)};
            }

            .card-alarms-text {
                font-size: 10px;
                color: var(--gray-700);
                font-weight: 400;

                &.unseen {
                    font-weight: 600;
                }
                &.alarm {
                }
                &.view {
                    font-weight: 600;
                    color: var(--blue-500);
                    cursor: pointer;
                }
            }
        }

        .card-status {
            line-height: 16px;
            font-size: 11px;
            color: var(--green-700);
            font-family: var(--font-semibold);
            vertical-align: super;
        }

        .card-spacer {
            flex: 1;
        }

        .card-degraded-percentage {
            margin-top: auto;
            font-size: 11px;
            width: 90%;

            span {
                font-size: 14px;
                font-family: var(--font-bold);
            }
        }

        .card-degraded-barriers {
            line-height: 16px;
            border-top: 1px solid var(--gray-400);
            font-size: 11px;
            width: min-content;
            white-space: nowrap;
            padding-right: 12px;

            span {
                font-size: 14px;
                font-family: var(--font-bold);
            }
        }
    }

    .card-side {
        max-width: 130px;
        word-break: break-all;
        white-space: unset;

        .card-asset-thumbnail {
            height: 80px;
            width: 80px;
            margin-left: auto;

            border-radius: 40px;
            img {
                height: 80px;
                width: 80px;
                border-radius: 40px;
                object-fit: cover;
            }
        }

        .card-supervisor {
            margin-top: 30px;
            width: 80px;

            div {
                text-align: right;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .status-row {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid var(--gray-300);
        padding: 1px;
        width: 100%;
        color: var(--gray-600);
        font-size: 11px;

        .gauge-div {
            width: 80px;
        }

        .status-col {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-left: 4px;
            padding-right: 4px;
            .norule-row {
                display: flex;
                flex-direction: row;
                align-items: baseline;
            }

            &.align-left {
                align-items: flex-start;
            }

            &.align-center {
                align-items: center;
            }
            &.align-right {
                align-items: flex-end;
            }
        }
    }
`

export const CardOperations = styled.div<{ operations: number }>`
    margin: 0 auto;
    padding-top: 8px;
    width: 90%;
    min-height: ${({ operations }) => (operations > 6 ? 333 : operations * 48)}px;
    max-height: 333px;
    background: var(--gray-0);
    border-radius: 0 0 3px 3px;
    overflow-x: hidden;
    overflow-y: auto;

    /* width */
    ::-webkit-scrollbar {
        width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: var(--gray-200);
        border-radius: 20px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--gray-600);
        border-radius: 20px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: var(--gray-700);
    }

    scrollbar-width: thin;
    scrollbar-track-color: var(--gray-200);
    scrollbar-color: var(--gray-600);
    scrollbar-highlight-color: var(--gray-700);
    scrollbar-shadow-color: var(--gray-200);
`

export const ExportPDFContainer = styled.div`
    background: var(--gray-300);
    min-height: 841px;
    padding: 0 30px 0 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 600px;
    justify-content: center;
`

export const ExportPDFCardContainer = styled.div`
    width: 255px;
    margin-bottom: 30px;
    min-height: 841px;

    .export-pdf {
        &.button-download {
            display: none;
        }

        &.card-details {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 70%;
            height: 290px;
        }

        &.card-degraded-percentage {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        &.card-header {
            width: 300px;
            height: calc((${pageHeight} / 13) * 5);
            img {
                height: 50px;
                width: 50px;
            }
        }

        &.card-side {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: space-between;
            width: 50px;
        }
        &.card-supervisor {
            width: 50px;
            .card-label {
                font-size: 8px;
            }

            .card-item {
                font-size: 8px !important;
            }
        }

        &.card-operations {
            width: 300px;
            margin-left: 0px;
            max-height: none;
            padding-top: 0;
        }

        &.card-title {
            font-size: 12px;
            display: flex;
            gap: 12px;
            .card-asset-id {
                font-size: 6px;
            }
        }
        &.card-alarms {
            .card-alarms-text {
                &.view {
                    display: none;
                }
            }
        }
        &.gauge-div {
            width: 60px;
        }
        &.status-row {
            font-size: 8px;
            line-height: 16px;
        }
        &.norule-row {
            > span {
                font-size: 8px;
            }
        }

        &.fa-bell,
        .fa-check-circle,
        .fa-exclamation-triangle,
        .fa-chevron-up,
        .fa-chevron-down {
            display: none;
        }

        &.fa-check-circle {
            display: none;
        }

        &.operation-item-degraded-barriers {
            display: flex;
            font-size: 8px;
            word-spacing: 10px;

            > span {
                font-size: 8px;
            }
        }

        .operation-item-description {
            font-size: 8px;
        }
        &.operation-item-bowties {
            display: none;
        }
    }
`

export const ExportPDFLevelTwoContainer = styled.div`
    padding: 0px 30px 0 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 600px;
    justify-content: center;
    background: var(--gray-300);
    min-height: 841px;

    .export-pdf {
        &.button-download {
            display: none;
        }

        &.card-details {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 70%;
            height: 290px;
        }

        &.card-degraded-percentage {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        &.card-header {
            width: 300px;
            height: calc((${pageHeight} / 13) * 5);
            img {
                height: 50px;
                width: 50px;
            }
        }

        &.card-side {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: space-between;
            width: 50px;
        }
        &.card-supervisor {
            width: 50px;
            .card-label {
                font-size: 8px;
            }

            .card-item {
                font-size: 8px !important;
            }
        }

        &.card-operations {
            width: 300px;
            margin-left: 0px;
            max-height: none;
            padding-top: 0;
        }

        &.card-title {
            font-size: 12px;
            display: flex;
            gap: 12px;
            .card-asset-id {
                font-size: 6px;
            }
        }
        &.card-alarms {
            .card-alarms-text {
                &.view {
                    display: none;
                }
            }
        }
        &.gauge-div {
            width: 60px;
        }
        &.status-row {
            font-size: 8px;
            line-height: 16px;
        }
        &.norule-row {
            > span {
                font-size: 8px;
            }
        }

        &.fa-bell,
        .fa-check-circle,
        .fa-exclamation-triangle,
        .fa-chevron-up,
        .fa-chevron-down,
        .fa-check,
        .fa-exclamation,
        .fa-times {
            display: none;
        }

        &.fa-check-circle {
            display: none;
        }

        &.operation-item-degraded-barriers {
            display: flex;
            font-size: 8px;
            word-spacing: 10px;

            > span {
                font-size: 8px;
            }
        }

        .operation-header {
            height: calc(${pageHeight} / 13);
        }

        .operation-item-description {
            font-size: 8px;
        }

        &.operation-item-bowties {
            display: flex;

            padding: 0px 8px 0px 8px;
            gap: 0px;
        }

        &.operation-bowtie-header {
            height: calc(${pageHeight} / 13);
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &.operation-bowtie-barrier-label {
            font-size: 6px !important;
        }

        &.number-count-bowtie {
            font-size: 8px !important;
            flex: 3;
        }

        &.number-count-prevention-mitigation {
            font-size: 8px !important;
            margin: 0 17px;
        }

        &.operation-bowtie-degraded-count {
            font-size: 6px !important;
            line-height: 10px !important;
            letter-spacing: 1px;
            height: 100%;
            width: 80px;
            word-wrap: break-word;
            flex-wrap: wrap;
            flex: 1;
        }

        &.operation-bowtie-description {
            font-size: 8px !important;
            font-weight: bold;
            line-height: 8px;
            width: 90px;
            height: min-content;
            flex: 1;
        }

        &.operation-bowtie-details {
            width: 80px !important;
        }

        &.operation-bowtie-name {
            font-size: 6px !important;
            width: 80px;
            line-height: 8px;
        }

        &.operation-bowtie-status {
            font-size: 6px;
            line-height: 10px;
            word-wrap: break-word;
            flex: 2;
        }

        &.operation-bowtie-item-styled {
            height: calc(${pageHeight} / 13);
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &.bowtie-details {
            align-items: center;
        }
    }
`

export const ExportButtonBar = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    background: none;
    border: none;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 0;
    top: 0;

    .button-svg {
        background: none;
        border: none;
        display: flex;
        &:focus:not(:focus-visible) {
            outline: 0;
            box-shadow: none;
        }

        .fa-ellipsis-v {
            color: #37a3ef;
        }
    }
`
